import { CompletedGridColumnId } from 'view/routes/requests/completed/CompletedNegotiationsGrid/CompletedGridColumnNames'

export enum ClearingGridColumnId {
  CLEARING_VENUE = 'CLEARING_VENUE',
  COUNTERPARTY_CLEARING = 'COUNTERPARTY_CLEARING',
  COUNTERPARTY_SPONSOR = 'COUNTERPARTY_SPONSOR',
  EXECUTING_COUNTERPARTY_NAME = 'EXECUTING_COUNTERPARTY_NAME',
  EXECUTING_COUNTERPARTY_SPONSOR = 'EXECUTING_COUNTERPARTY_SPONSOR'
}

export enum CollectionColumnId {
  COLLECTION_ID = 'COLLECTION_ID',
  COLLECTION_NAME = 'COLLECTION_NAME',
  COLLECTION_TYPE = 'COLLECTION_TYPE'
}

export enum ContainerCollectionColumnId {
  CONTAINER_COLLECTION_ID = 'CONTAINER_COLLECTION_ID',
  CONTAINER_COLLECTION_NAME = 'CONTAINER_COLLECTION_NAME'
}

export enum CollateralBasketColumnId {
  COLLATERAL_BASKET_DESCRIPTION = 'COLLATERAL_BASKET_DESCRIPTION',
  COLLATERAL_BASKET_DEAL_ID = 'COLLATERAL_BASKET_DEAL_ID',
  COLLATERAL_BASKET_DBV_CLASS = 'COLLATERAL_BASKET_DBV_CLASS',
  COLLATERAL_BASKET_REMAINING_ALLOCATION_TIME = 'COLLATERAL_BASKET_REMAINING_ALLOCATION_TIME'
}

export const AdminOnlyColumnIds: string[] = [
  ClearingGridColumnId.EXECUTING_COUNTERPARTY_SPONSOR,
  CompletedGridColumnId.EXTERNAL_NEGOTIATION_ID,
  CompletedGridColumnId.EXTERNAL_ORDER_ID,
  CompletedGridColumnId.ORDER_ID,
  CompletedGridColumnId.EXTERNAL_QUOTE_ID,
  CompletedGridColumnId.EXTERNAL_QUOTE_RESPONSE_ID,
  CompletedGridColumnId.MY_FICC_ENTITY_SHORT_NAME
]

export const ROE = 'RIGHT_OF_EXIT'
export const ROS = 'RIGHT_OF_SUBSTITUTION'
export const ISSUE = 'ISSUE'
export const MARKET_TYPE = 'MARKET_TYPE'
export const MIC = 'MIC'

export const TREE_DATA_GROUP_BY_COLLECTION_KEY = 'treeDataGroupByCollection'
